import { combineReducers } from 'redux';
import { reportsCenterReducer } from './reportsCenterReducer';
import ui from './ui';
import { generateReportReducer } from './generateReportReducer';

const rootReducer = combineReducers({
  reportsCenter: reportsCenterReducer,
  generateReport: generateReportReducer,
  ui,
});

export default rootReducer;
